import React from 'react';
import { Container, Typography, Box, Grid, Paper, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { CheckCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const AboutRunnersHubPage: React.FC = () => {
  const { t } = useTranslation();
  const features = t('about.features', { returnObjects: true }) as string[];

  return (
    <Container maxWidth="md" sx={{ pt: 8, pb: 6 }}>
      <Typography variant="h3" component="h1" align="center" fontWeight={800} gutterBottom>
        {t('about.title')}
      </Typography>
      <Typography variant="h6" align="center" color="text.secondary" sx={{ mb: 5 }}>
        {t('about.subtitle')}
      </Typography>

      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <Paper elevation={0} sx={{ p: 3, borderRadius: 3, border: (theme) => `1px solid ${theme.palette.divider}` }}>
            <Typography variant="h5" fontWeight={700} gutterBottom>
              {t('about.whatYouCanDo')}
            </Typography>
            <List>
              {features.map((text: string, index: number) => (
                <ListItem key={index} sx={{ pl: 0 }}>
                  <ListItemIcon sx={{ minWidth: 32 }}>
                    <CheckCircle size={18} />
                  </ListItemIcon>
                  <ListItemText primary={text} />
                </ListItem>
              ))}
            </List>
          </Paper>
        </Grid>
        <Grid item xs={12} md={6}>
          <Paper elevation={0} sx={{ p: 3, borderRadius: 3, border: (theme) => `1px solid ${theme.palette.divider}` }}>
            <Typography variant="h5" fontWeight={700} gutterBottom>
              {t('about.poweredBy')}
            </Typography>
            <Typography variant="body1" color="text.secondary" paragraph>
              {t('about.poweredByText')}
            </Typography>
            <Typography variant="body1" color="text.secondary">
              <span dangerouslySetInnerHTML={{ __html: t('about.feedback') }} />
            </Typography>
          </Paper>
        </Grid>
      </Grid>

      <Box mt={6}>
        <Typography variant="h5" fontWeight={700} gutterBottom>
          {t('about.whatsNext')}
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          {t('about.whatsNextText')}
        </Typography>
      </Box>
    </Container>
  );
};

export default AboutRunnersHubPage;
